export const CelebrateSunIcon = (): JSX.Element => (
  <svg width="232" height="222" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M130.208 26.084c.167 3.35 2.028 5.59 3.434 7.28l.196.236c1.509 1.823 2.426 3.084 2.353 4.99-.066 1.71-1.005 3.94-2.114 5.932a33.943 33.943 0 0 1-1.494 2.43 73.964 73.964 0 0 0-7.638-.942c.426-2.688-.552-5.76-2.794-8.088-1.802-1.87-3.531-2.391-5.235-2.678-.343-.057-.67-.105-.99-.152-1.196-.175-2.289-.335-3.718-.934-1.533-.641-2.071-1.54-2.295-2.174a3.15 3.15 0 0 1-.178-1.114l.002-.028a2 2 0 0 0-3.968-.502l1.982.268c-1.982-.268-1.982-.267-1.983-.265v.002l-.001.005-.001.012-.003.027-.008.07-.015.206c-.008.164-.012.383.002.643.027.519.123 1.225.399 2.008.575 1.627 1.879 3.426 4.523 4.532 1.94.812 3.606 1.051 4.84 1.228.271.039.521.075.749.113 1.185.199 2.005.457 3.017 1.508 1.738 1.805 2 3.804 1.603 5.136-41.942-.667-77.631 34.397-80.512 79.962-2.96 46.831 29.857 87.021 73.3 89.767 54.58 3.45 81.06-32.991 84.02-79.822 1.137-17.986-3.003-34.992-10.996-49.274-.23-.41-.463-.819-.699-1.225a39.543 39.543 0 0 1-.37-3.427c-.206-3.312.063-6.749 1.368-8.823.893-1.421 2.181-2.018 4.051-2.625.303-.099.622-.198.957-.3l.13-.04c2.219-.681 5.19-1.592 7.022-4.683 1.731-2.92 1.917-6.977 1.792-9.953a41.098 41.098 0 0 0-.553-5.13 22.361 22.361 0 0 0-.079-.426l-.005-.027-.001-.008-.001-.003c0-.001 0-.002-1.917.388l1.917-.39a2 2 0 0 0-3.92.797l-4.1 15.178h-.001c-.446.158-.931.31-1.458.472l-.21.065c-2.193.67-5.133 1.57-7.01 4.555-1.369 2.176-1.885 4.962-2.012 7.582-10.9-15.19-26.566-26.293-44.806-30.624.254-.413.522-.867.792-1.352 1.15-2.066 2.512-5.004 2.616-7.723.137-3.58-1.794-5.913-3.261-7.684l-.008-.01c-1.554-1.878-2.617-3.182-2.715-5.164-.065-1.292.226-3.064.584-4.635a38.419 38.419 0 0 1 .691-2.602l.011-.034.002-.007a2 2 0 1 0-3.811-1.215l1.906.607-1.906-.607v.001l-.001.002-.001.004-.004.014-.015.048-.053.173a42.883 42.883 0 0 0-.719 2.728c-.372 1.63-.772 3.851-.68 5.721Zm62.069 39.684 4.1-15.176.003.014.013.067.011.062a93.442 93.442 0 0 0 .039.216 36.734 36.734 0 0 1 .496 4.608c.123 2.9-.148 5.908-1.236 7.745-.765 1.29-1.858 1.91-3.426 2.465Z"
      fill="#FDDA05"
    />
    <path
      d="M53.336 88.595s1.906-9.373-.913-14.13c-2.851-4.81-9.157-2.87-12.134-7.603-3.34-5.31-.836-16.042-.836-16.042"
      stroke="#FDDA05"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <g filter="url(#a)">
      <ellipse
        cx="81.5"
        cy="90.5"
        rx="8.5"
        ry="7.5"
        fill="#FB9378"
        fillOpacity=".38"
      />
    </g>
    <g filter="url(#b)">
      <ellipse
        cx="147.813"
        cy="82.508"
        rx="8.5"
        ry="7.963"
        transform="rotate(-21.317 147.813 82.508)"
        fill="#FB9378"
        fillOpacity=".38"
      />
    </g>
    <path
      d="M127.403 83s-1.759 5.185-11.361 5.9c-9.602.715-11.043-4.232-11.043-4.232"
      stroke="#CFB202"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="97" cy="78" r="2" fill="#666" />
    <circle cx="133" cy="76" r="2" fill="#666" />
    <path
      d="m189.11 9.35 15.731 10.896-10.583 7.535-5.148-18.43Z"
      fill="#259BE9"
    />
    <path
      d="m91.559 8.676 10.205 3.713-6.164 6.367-4.041-10.08Z"
      fill="#51DACF"
    />
    <path d="m34.844 90.686 3.06 10.42-8.781-1.19 5.72-9.23Z" fill="#FB9378" />
    <path
      d="m182.654 53.368-.661 10.84-7.855-4.102 8.516-6.738Z"
      fill="#51DACF"
    />
    <path
      d="m21.055 30.85-.83 19.117-12.017-4.935L21.055 30.85Z"
      fill="#AFDAF7"
    />
    <circle cx="49" cy="16" r="3" fill="#FB9378" />
    <circle cx="169" cy="37" r="3" fill="#FB9378" />
    <circle cx="91" cy="40" r="3" fill="#259BE9" />
    <circle cx="201" cy="90" r="3" fill="#FB9378" />
    <path fill="#53B0EE" d="m218.559 51 2.713 1.28-2.559 5.426-2.713-1.28z" />
    <path fill="#82C5F3" d="M154 13.279 156.714 12l2.557 5.428-2.713 1.279z" />
    <path fill="#53B0EE" d="m60.559 40 2.713 1.28-2.559 5.427L58 45.427z" />
    <path fill="#51DACF" d="M16 67.992 18.243 66l3.984 4.485-2.242 1.993z" />
    <defs>
      <filter
        id="a"
        x="71"
        y="81"
        width="21"
        height="19"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="b"
        x="137.381"
        y="72.47"
        width="20.865"
        height="20.077"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
    </defs>
  </svg>
);
